// Helper para registrar / desregistrar Web Push Notifications
import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    let reg = await navigator.serviceWorker.getRegistration("/");
    if (!reg) {
      reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    }
    await navigator.serviceWorker.ready;
    return reg;
  } catch (e) {
    console.warn("SW register fail", e);
    return null;
  }
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, permission: "denied", subscribed: false };
  const permission = Notification.permission;
  const reg = await getServiceWorkerRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission, subscribed: !!sub, endpoint: sub?.endpoint || null };
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Tu navegador no soporta notificaciones push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permiso de notificaciones denegado");

  const reg = await getServiceWorkerRegistration();
  if (!reg) throw new Error("No se pudo registrar el service worker");

  // Obtener clave VAPID pública del backend
  const { data: vapid } = await api.get("/push/vapid-public-key");
  const appServerKey = urlBase64ToUint8Array(vapid.key);

  // Suscribirse (reusa si existe)
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });
  }

  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const reg = await getServiceWorkerRegistration();
  if (!reg) return false;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return false;
  const endpoint = sub.endpoint;
  try {
    await sub.unsubscribe();
  } catch (e) { /* ignore */ }
  try {
    await api.post("/push/unsubscribe", { endpoint });
  } catch (e) { /* ignore */ }
  return true;
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test", {
    title: "🔔 Test RotulaciónDNF",
    body: "Si ves esto, las notificaciones funcionan ✅",
    url: "/fotos-pendientes",
  });
  return data;
}
